import { TableHead, TableRow, TableCell } from '@mui/material'

const TableHeader = ({bgColor}) => {
    return ( 
        <TableHead>
          <TableRow sx={{ backgroundColor: `${bgColor}` }}>
            <TableCell>Title</TableCell>
            <TableCell align="right">Quantity&nbsp;</TableCell>
            <TableCell align="right">Retailer Name</TableCell>
            <TableCell align="right">Time stored&nbsp;</TableCell>
            <TableCell align="right">Category&nbsp;</TableCell>
          </TableRow>
        </TableHead>
     );
}
 
export default TableHeader;